import { HttpClient, HttpEvent, HttpEventType, HttpHandler, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from "@angular/core"; import { Location } from "@angular/common";

import { from, lastValueFrom, Observable, of } from 'rxjs';
import { catchError, filter, last, map, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { ContactEntite } from '../entites/contact';
import { ReponseObtenirDocuments } from './reponses/reponse-obtenir-documents';
import { RequeteObtenirDocuments } from './requetes/requete-obtenir-documents';
import { RequeteObtenirImage } from './requetes/requete-obtenir-image';
import { DocumentEntite } from '../entites/document';
import { RequeteAjouterDocuments } from './requetes/requete-ajouter-documents';
import { DocumentLieEntite } from '../entites/document-lie';
import { ETypeLien } from '../entites/enums/type-lien-document';
import { TypeDocumentEntite } from '../entites/type-document';
import { DonneesBaseService } from './donnees-base-service';
import { ProfilService } from './profil-service';
import { ContexteService } from './contexte-service';
import { MessageService } from 'primeng/api';
import { EStatuts } from '../entites/enums/statuts';
import { BaseService } from './base.service';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { SupabaseService } from './supabase.service';
import { NotificationService } from '../services/notification-service';
import { HttpBackend } from '@angular/common/http';
import { RequeteCompleterUploadR2 } from './requetes/requete-completer-upload-r2';
import { DocumentUpload } from './reponses/reponse-r2-presigned';

@Injectable({ providedIn: 'root' })
export class DocumentService extends BaseService {

  private obtenirTypesDocumentsUrl = environment.apiBaseUrl + 'document/{typeLien}/typesdocuments';
  private ajouterTypeDocumentUrl = environment.apiBaseUrl + 'document/typesdocuments';
  private modifierTypeDocumentUrl = environment.apiBaseUrl + 'document/typesdocuments';
  private supprimerTypeDocumentUrl = environment.apiBaseUrl + 'document/typesdocuments/{id}';
  private obtenirListeItemLies = environment.apiBaseUrl + 'document/obtenirlies';
  private obtenirApercusUrl = environment.apiBaseUrl + 'document/{type}/apercu?id={id}';
  private obtenirListeDocumentsUrl = environment.apiBaseUrl + 'document/{type}/{id}';
  private obtenirDocumentsPublicsUrl = environment.apiBaseUrl + 'document/public/{uuid}';
  private ajouterDocumentLieUrl = environment.apiBaseUrl + 'document/creerdocumentlie';
  private modifierDocumentUrl = environment.apiBaseUrl + 'document/{typeLien}/{idLien}';
  private supprimerUrl = environment.apiBaseUrl + 'document/{id}';
  private verifierAccessPublicUrl = environment.apiBaseUrl + 'document/valider/{uuid}';
  private obtenirDocumentUrl = environment.apiBaseUrl + 'document/{id}';
  private obtenirPresignedUrlUrl = environment.apiBaseUrl + 'document/{id}/presignedurl';
  
  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  private publicHttp: HttpClient;

  constructor(
    public http: HttpClient,
    private httpBackend: HttpBackend,
    public router: Router,
    public sdb: DonneesBaseService,
    public profilService: ProfilService,
    public contexteService: ContexteService,
    public messageService: MessageService,
    private supabaseService: SupabaseService,
    private notificationService: NotificationService
  ) {
    super(messageService, router);
    this.publicHttp = new HttpClient(httpBackend);
  }

  /**
   * Initiate R2 presigned URL upload for multiple files
   */
  initierUploadR2(typeLien: ETypeLien, id: number, requete: DocumentUpload): Observable<DocumentUpload> {
    return this.http.post<DocumentUpload>(`${environment.apiBaseUrl}document/initiate/${typeLien}/${id}`, requete);
  }

  /**
   * Complete R2 upload process for multiple files
   */
  completerUploadR2(typeLien: ETypeLien, id: number, requete: DocumentUpload): Observable<HttpResponse<DocumentEntite[]>> {
    return this.http.post<DocumentEntite[]>(`${environment.apiBaseUrl}document/complete/${typeLien}/${id}`, requete, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), observe: 'response' });
  }

  public VideoUpload(document: DocumentEntite): Observable<HttpResponse<string>> {
    return this.http.post(`${environment.apiBaseUrl}document/video`, JSON.stringify(document), { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), responseType: "text", observe: 'response' });
  }


  public ModifierTypeDocument(typeDocument: TypeDocumentEntite): Observable<HttpResponse<TypeDocumentEntite>> {
    return this.http.put<TypeDocumentEntite>(this.modifierTypeDocumentUrl, JSON.stringify(typeDocument), { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), observe: 'response' });
  }


  public SupprimerTypeDocument(id: number): Observable<HttpResponse<TypeDocumentEntite>> {
    return this.http.delete<TypeDocumentEntite>(this.supprimerTypeDocumentUrl.replace('{id}', id.toString()), { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), observe: 'response' });
  }


  public ObtenirListeItemLies(requete: RequeteObtenirDocuments): Promise<ReponseBase<DocumentLieEntite[]>> {
    var p = this.http.post<ReponseBase<DocumentLieEntite[]>>(this.obtenirListeItemLies, JSON.stringify(requete), this.httpOptions)
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirListeDocuments(type: ETypeLien, id: number): Observable<HttpResponse<ReponseObtenirDocuments>> {
    return this.http.get<ReponseObtenirDocuments>(this.obtenirListeDocumentsUrl.replace('{type}', type.toString()).replace('{id}', id.toString()), {...this.httpOptions, observe: 'response'});
  }

  public VerifierAccessPublic(uuid: string): Observable<HttpResponse<boolean>> {
    return this.publicHttp.post<boolean>(this.verifierAccessPublicUrl.replace('{uuid}', uuid), {}, {...this.httpOptions, withCredentials: false, observe: 'response'});
  }

  public ObtenirDocumentsPublics(uuid: string): Observable<HttpResponse<ReponseObtenirDocuments>> {
    return this.publicHttp.get<ReponseObtenirDocuments>(this.obtenirDocumentsPublicsUrl.replace('{uuid}', uuid), {...this.httpOptions, withCredentials: false, observe: 'response'});
  }




  public ObtenirApercus(type: ETypeLien, ids: number[]): Observable<{ id: string, apercu: string }> {
    return new Observable(observer => {
      this.supabaseService.getAccessToken().then(token => {
        const eventSource = new EventSourcePolyfill(this.obtenirApercusUrl.replace('{type}', type.toString()).replace('{id}', ids.join('&id=')), {
          withCredentials: true,
          headers: {
            'Accept': 'text/event-stream',
            'Authorization': `Bearer ${token}`
          }
        });

        eventSource.onmessage = (event) => {
          if (event.data == 'fin') {
            eventSource.close();
            observer.complete();
          } else {
            observer.next({ id: event.lastEventId, apercu: event.data });
          }
        };

        eventSource.onerror = (error) => {
          observer.error(error);
          eventSource.close();
        };

        return () => {
          eventSource.close();
        };
      }).catch(error => {
        observer.error(error);
      });
    });
  }

  public ObtenirApercuCloudflare(path: string, size?: number): Observable<HttpEvent<Blob>> {
    return from(this.supabaseService.getAccessToken()).pipe(
      switchMap(token => {
        const isSvg = /\.svg(?:$|[?#])/i.test(path);
        const url = size && !isSvg ?
          environment.cloudflare.url + path + `?cf-image=resize,width=${size}` :
          environment.cloudflare.url + path;

        return this.http.get(url, { 
          responseType: 'blob', 
          observe: 'events',
          reportProgress: true,
          headers: new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Accept': 'image/*, */*'
          }),
          withCredentials: false
        }).pipe(
          tap({
            error: (error) => {
              console.error('Full error:', error);
              console.error('Status:', error.status);
              console.error('Status Text:', error.statusText);
              console.error('Message:', error.message); 
            }
          })
        );
      })
    );
  }

  public ObtenirPresignedUrl(id: number): Observable<string> {
    return this.http.get<string>(this.obtenirPresignedUrlUrl.replace('{id}', id.toString()));
  }

  public ObtenirDocument(id: number): Observable<DocumentEntite> {
    return this.http.get<DocumentEntite>(this.obtenirDocumentUrl.replace('{id}', id.toString()));
  }

  public AjouterDocumentsLie(requete: DocumentLieEntite): Promise<HttpResponse<DocumentLieEntite>> {
    var p = this.http.post<DocumentLieEntite>(this.ajouterDocumentLieUrl, JSON.stringify(requete), { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), observe: 'response' });
    return lastValueFrom(p);
  }

  public ModifierDocument(typeLien: ETypeLien, idLien: number, requete: DocumentEntite): Promise<ReponseBase<DocumentEntite>> {
    var p = this.http.put<ReponseBase<DocumentEntite>>(this.modifierDocumentUrl.replace('{typeLien}', typeLien.toString()).replace('{idLien}', idLien.toString()), JSON.stringify(requete), this.httpOptions)
      .toPromise();

    return p;
  }

  public SupprimerDocument(id: number): Promise<ReponseBase<number>> {
    var p = this.http.delete<ReponseBase<number>>(this.supprimerUrl.replace('{id}', id.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  /**
 * Generates an SHA-256 hash for a File object obtained from a file input.
 * @param {File} file - The File object (e.g., from event.target.files[0]).
 * @returns {Promise<string>} A promise that resolves to the hex hash string.
 */
public generateFileHash(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    // 1. Use FileReader to read the file content as an ArrayBuffer
    const reader = new FileReader();

    reader.onload = async (event) => {
      try {
        const arrayBuffer = event.target.result as ArrayBuffer;
        
        // 2. Use the Web Crypto API to generate the hash
        const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
        
        // 3. Convert the ArrayBuffer hash to a hexadecimal string
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
        const hashHex = hashArray
          .map(b => b.toString(16).padStart(2, '0')) // convert bytes to hex string
          .join('');

        resolve(hashHex);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = (error) => reject(error);

    // Start reading the file
    reader.readAsArrayBuffer(file);
  });
}
}
